export default __webpack_public_path__ + "static/media/IMG_2382.7f17a693.jpg";